import DataSetResponseStatusContainer from './data_set_response_status_container';

const DataSetResponseStatus = DataSetResponseStatusContainer;

export default DataSetResponseStatus;
